export const states = [
  /*{
    id: 7,
    slug: 'sabah',
    nameKey: 'state_7',
    totalSeats: 73,
    mapKey: 'sabah',
    banner: { d: 'flags/sabahbanner_desktop.jpg', m: 'flags/sabahbanner_mobile.jpg' },
    enabled: true,
  },*/
  {
    id: 5,
    slug: 'negerisembilan',
    nameKey: 'state_5',
    totalSeats: 36,
    mapKey: 'negerisembilan',
    banner: { d: 'flags/n9banner_desktop.jpg', m: 'flags/n9banner_mobile.jpg' },
    flag: 'flags/flag_n9.png',
    electionId: null, // set when NS election is created in the dashboard
    enabled: false,
  },
  {
    id: 8,
    slug: 'johor',
    nameKey: 'state_8',
    totalSeats: 56,
    mapKey: 'johor',
    banner: { d: 'flags/johorbanner_desktop.jpg', m: 'flags/johorbanner_mobile.jpg' },
    flag: 'flags/flag_johor.jpg',
    electionId: 21, // elections.id for JOHOR-2026 — pins every public-api call permanently
    enabled: true,
  },
  {
    id: 9,
    slug: 'melaka',
    nameKey: 'state_9',
    totalSeats: 28,
    mapKey: 'melaka',
    banner: { d: 'flags/melakabanner_desktop.jpg', m: 'flags/melakabanner_mobile.jpg' },
    flag: 'flags/flag_melaka.png',
    electionId: null,
    enabled: false,
  },
];

export const enabledStates = () => states.filter((s) => s.enabled);
export const getStateBySlug = (slug) => states.find((s) => s.slug === slug);
export const getStateById = (id) => states.find((s) => s.id === id);

// The election this deployment is pinned to. Sent on every public-api request so
// an archived site keeps serving its own election even after newer ones go live.
export const activeElectionId = () => (enabledStates()[0] || {}).electionId || null;
